import { ItemData, ItemType } from "../IronmonMapUtils";

export const defaultItemHeight = 12;
export const defaultItemWidth = 12;

export const items: ItemData[] = [
  // New Bark Town
  {
    x: 9754,
    y: 4738,
    type: ItemType.Hidden,
  },

  // Rt 29
  {
    x: 9309,
    y: 4679,
    type: ItemType.Normal,
  },

  // Cherrygrove
  {
    x: 7202,
    y: 4680,
    type: ItemType.Hidden,
  },

  // Rt 30
  {
    x: 7998,
    y: 4727,
    type: ItemType.Hidden,
  },
  {
    x: 7858,
    y: 4495,
    type: ItemType.Normal,
  },
  {
    x: 7708,
    y: 4149,
    type: ItemType.Normal,
  },
  {
    x: 7725,
    y: 3859,
    type: ItemType.Hidden,
  },

  // Rt 31
  {
    x: 7758,
    y: 3222,
    type: ItemType.Normal,
  },
  {
    x: 7567,
    y: 3376,
    type: ItemType.Normal,
  },

  // Violet City
  {
    x: 6935,
    y: 2996,
    type: ItemType.Hidden,
  },
  {
    x: 6548,
    y: 2783,
    type: ItemType.Hidden,
  },
  {
    x: 6907,
    y: 2720,
    type: ItemType.Normal,
  },
  {
    x: 6205,
    y: 2597,
    type: ItemType.Normal,
  },

  // Ruins of Alph
  {
    x: 5748,
    y: 3311,
    type: ItemType.Normal,
  },
  {
    x: 5583,
    y: 3391,
    type: ItemType.Hidden,
  },
  {
    x: 5485,
    y: 3830,
    type: ItemType.Hidden,
  },
  {
    x: 5567,
    y: 3793,
    type: ItemType.Hidden,
  },
  {
    x: 5872,
    y: 3608,
    type: ItemType.Hidden,
  },
  {
    x: 5487,
    y: 3329,
    type: ItemType.Normal,
  },

  // Sprout Tower
  // 1F
  {
    x: 6164,
    y: 2369,
    type: ItemType.Normal,
  },

  // 2F
  {
    x: 6249,
    y: 2281,
    type: ItemType.Normal,
  },

  // 3F
  {
    x: 6840,
    y: 2502,
    type: ItemType.Normal,
  },
  {
    x: 6965,
    y: 2273,
    type: ItemType.Normal,
  },

  // Rt 32
  {
    x: 6196,
    y: 3772,
    type: ItemType.Hidden,
  },
  {
    x: 6151,
    y: 4120,
    type: ItemType.Normal,
  },
  {
    x: 6199,
    y: 4676,
    type: ItemType.Normal,
  },
  {
    x: 6456,
    y: 4635,
    type: ItemType.Hidden,
  },
  {
    x: 6071,
    y: 4908,
    type: ItemType.TM,
  },
  {
    x: 6217,
    y: 5309,
    type: ItemType.Hidden,
  },
  {
    x: 6450,
    y: 5396,
    type: ItemType.Normal,
  },

  // Union Cave
  // 1F
  {
    x: 6587,
    y: 3723,
    type: ItemType.Normal,
  },
  {
    x: 7015,
    y: 4014,
    type: ItemType.Hidden,
  },
  {
    x: 7002,
    y: 4190,
    type: ItemType.Normal,
  },
  {
    x: 6603,
    y: 4129,
    type: ItemType.Normal,
  },
  {
    x: 6827,
    y: 4237,
    type: ItemType.Hidden,
  },
  {
    x: 6907,
    y: 4448,
    type: ItemType.Normal,
  },

  // B1F
  {
    x: 6987,
    y: 4890,
    type: ItemType.Normal,
  },
  {
    x: 6875,
    y: 5047,
    type: ItemType.Hidden,
  },
  {
    x: 6731,
    y: 5037,
    type: ItemType.TM,
  },

  // Azalea Town
  {
    x: 5621,
    y: 5704,
    type: ItemType.Hidden,
  },

  // Slowpoke Well
  {
    x: 6865,
    y: 5547,
    type: ItemType.Normal,
  },
  {
    x: 6929,
    y: 5685,
    type: ItemType.Hidden,
  },

  // Ilex Forest
  {
    x: 5621,
    y: 5289,
    type: ItemType.Normal,
  },
  {
    x: 5795,
    y: 4984,
    type: ItemType.Hidden,
  },
  {
    x: 5189,
    y: 4844,
    type: ItemType.Hidden,
  },
  {
    x: 5377,
    y: 4907,
    type: ItemType.Normal,
  },
  {
    x: 5270,
    y: 4755,
    type: ItemType.Normal,
  },
  {
    x: 5398,
    y: 4711,
    type: ItemType.Hidden,
  },
  {
    x: 5526,
    y: 4706,
    type: ItemType.Hidden,
  },
  {
    x: 5751,
    y: 4759,
    type: ItemType.Hidden,
  },
  {
    x: 5619,
    y: 4602,
    type: ItemType.Hidden,
  },
  {
    x: 5698,
    y: 4589,
    type: ItemType.Normal,
  },
  {
    x: 5572,
    y: 4535,
    type: ItemType.Hidden,
  },
  {
    x: 5474,
    y: 4561,
    type: ItemType.Hidden,
  },
  {
    x: 5113,
    y: 4783,
    type: ItemType.Hidden,
  },

  // Rt 34
  {
    x: 5000,
    y: 5062,
    type: ItemType.Hidden,
  },
  {
    x: 4857,
    y: 4733,
    type: ItemType.TM,
  },
  {
    x: 4715,
    y: 5295,
    type: ItemType.Hidden,
  },
  {
    x: 4733,
    y: 5319,
    type: ItemType.Normal,
  },

  // Goldenrod City
  {
    x: 4808,
    y: 4608,
    type: ItemType.Hidden,
  },

  // Dept Store Basement
  {
    x: 5333,
    y: 3956,
    type: ItemType.Hidden,
  },
  {
    x: 5223,
    y: 3990,
    type: ItemType.Hidden,
  },
  {
    x: 5397,
    y: 4092,
    type: ItemType.Normal,
  },
  {
    x: 5285,
    y: 4105,
    type: ItemType.Normal,
  },
  {
    x: 5445,
    y: 3858,
    type: ItemType.Normal,
  },
  {
    x: 5031,
    y: 3928,
    type: ItemType.Hidden,
  },
  {
    x: 5205,
    y: 3869,
    type: ItemType.Normal,
  },

  // Rt 35
  {
    x: 4983,
    y: 3834,
    type: ItemType.TM,
  },
  {
    x: 4622,
    y: 3350,
    type: ItemType.Hidden,
  },
  {
    x: 4900,
    y: 3339,
    type: ItemType.Normal,
  },

  // Rt 36
  {
    x: 5158,
    y: 2897,
    type: ItemType.Hidden,
  },

  // National Park
  {
    x: 3590,
    y: 4649,
    type: ItemType.Hidden,
  },
  {
    x: 3970,
    y: 4095,
    type: ItemType.Normal,
  },
  {
    x: 3127,
    y: 4399,
    type: ItemType.TM,
  },
  {
    x: 3396,
    y: 4453,
    type: ItemType.Hidden,
  },
  {
    x: 4032,
    y: 3863,
    type: ItemType.Normal,
  },

  // Pokeathalon
  {
    x: 4183,
    y: 4990,
    type: ItemType.Hidden,
  },
  {
    x: 3667,
    y: 5211,
    type: ItemType.Hidden,
  },

  // Rt 36
  {
    x: 5192,
    y: 2812,
    type: ItemType.Normal,
  },

  // Ecruteak
  {
    x: 5403,
    y: 1901,
    type: ItemType.Hidden,
  },
  {
    x: 5063,
    y: 1990,
    type: ItemType.Hidden,
  },
  {
    x: 4974,
    y: 1686,
    type: ItemType.Hidden,
  },
  {
    x: 4744,
    y: 1917,
    type: ItemType.Hidden,
  },

  // Burned Tower
  // 1F
  {
    x: 4590,
    y: 2039,
    type: ItemType.Hidden,
  },
  {
    x: 4650,
    y: 2080,
    type: ItemType.Normal,
  },
  {
    x: 4539,
    y: 2262,
    type: ItemType.Hidden,
  },
  {
    x: 4524,
    y: 2290,
    type: ItemType.Normal,
  },

  // B1F
  {
    x: 4573,
    y: 2352,
    type: ItemType.Hidden,
  },
  {
    x: 4495,
    y: 2342,
    type: ItemType.TM,
  },
  {
    x: 4654,
    y: 2561,
    type: ItemType.Hidden,
  },

  // Rt 38
  {
    x: 4167,
    y: 2078,
    type: ItemType.Normal,
  },
  {
    x: 3655,
    y: 2187,
    type: ItemType.Normal,
  },
  {
    x: 3565,
    y: 2056,
    type: ItemType.Hidden,
  },

  // Rt 39
  {
    x: 3046,
    y: 2055,
    type: ItemType.Hidden,
  },
  {
    x: 3238,
    y: 2104,
    type: ItemType.Hidden,
  },
  {
    x: 3155,
    y: 2252,
    type: ItemType.Hidden,
  },
  {
    x: 3014,
    y: 2201,
    type: ItemType.TM,
  },

  // Olivine City
  {
    x: 3463,
    y: 2748,
    type: ItemType.Hidden,
  },
  {
    x: 3317,
    y: 3417,
    type: ItemType.Hidden,
  },
  {
    x: 3454,
    y: 3532,
    type: ItemType.Hidden,
  },
  {
    x: 3844,
    y: 3000,
    type: ItemType.TM,
  },

  // Lighthouse
  // 3F
  {
    x: 2794,
    y: 2784,
    type: ItemType.Hidden,
  },
  {
    x: 2934,
    y: 2772,
    type: ItemType.Normal,
  },

  // 3F Balcony
  {
    x: 2454,
    y: 2621,
    type: ItemType.Normal,
  },

  // 4F
  {
    x: 2746,
    y: 2532,
    type: ItemType.TM,
  },

  // 5F
  {
    x: 2885,
    y: 2179,
    type: ItemType.Normal,
  },

  // 6F
  {
    x: 2946,
    y: 2006,
    type: ItemType.Normal,
  },

  // Rt 40
  {
    x: 2933,
    y: 3618,
    type: ItemType.TM,
  },
  {
    x: 2922,
    y: 3629,
    type: ItemType.Hidden,
  },

  // Cianwood City
  {
    x: 1573,
    y: 4076,
    type: ItemType.Hidden,
  },
  {
    x: 1874,
    y: 4384,
    type: ItemType.Hidden,
  },

  // Cliff Cave
  {
    x: 1455,
    y: 3834,
    type: ItemType.Hidden,
  },
  {
    x: 633,
    y: 4774,
    type: ItemType.Hidden,
  },
  {
    x: 753,
    y: 4412,
    type: ItemType.Normal,
  },
  {
    x: 672,
    y: 4490,
    type: ItemType.Hidden,
  },
  {
    x: 163,
    y: 4476,
    type: ItemType.Hidden,
  },
  {
    x: 608,
    y: 4257,
    type: ItemType.Normal,
  },
  {
    x: 163,
    y: 3538,
    type: ItemType.Normal,
  },
  {
    x: 128,
    y: 3986,
    type: ItemType.Normal,
  },
  {
    x: 131,
    y: 4549,
    type: ItemType.Normal,
  },

  // Safari Zone
  {
    x: 209,
    y: 3159,
    type: ItemType.Hidden,
  },
  {
    x: 339,
    y: 3098,
    type: ItemType.Hidden,
  },
  {
    x: 561,
    y: 3085,
    type: ItemType.Hidden,
  },

  // Bellchime Trail
  {
    x: 2834,
    y: 1542,
    type: ItemType.Hidden,
  },
  {
    x: 2880,
    y: 1541,
    type: ItemType.Hidden,
  },
  {
    x: 2976,
    y: 1540,
    type: ItemType.Hidden,
  },
  {
    x: 3137,
    y: 1590,
    type: ItemType.Hidden,
  },
  {
    x: 3234,
    y: 1711,
    type: ItemType.Hidden,
  },

  // Rt 42
  {
    x: 5789,
    y: 1981,
    type: ItemType.TM,
  },
  {
    x: 6585,
    y: 2137,
    type: ItemType.Hidden,
  },
  {
    x: 6455,
    y: 2067,
    type: ItemType.Normal,
  },

  // Rt 43
  {
    x: 7418,
    y: 1588,
    type: ItemType.Normal,
  },

  // Lake of Rage
  {
    x: 7080,
    y: 900,
    type: ItemType.Hidden,
  },
  {
    x: 6738,
    y: 791,
    type: ItemType.Normal,
  },
  {
    x: 7004,
    y: 311,
    type: ItemType.TM,
  },
  {
    x: 7544,
    y: 352,
    type: ItemType.Normal,
  },
  {
    x: 7577,
    y: 340,
    type: ItemType.Hidden,
  },
  {
    x: 7659,
    y: 860,
    type: ItemType.Hidden,
  },

  // Rocket Hideout

  // B1F
  {
    x: 8302,
    y: 1189,
    type: ItemType.Normal,
  },
  {
    x: 8110,
    y: 1325,
    type: ItemType.Normal,
  },
  {
    x: 8319,
    y: 1247,
    type: ItemType.Hidden,
  },
  {
    x: 7949,
    y: 1396,
    type: ItemType.Normal,
  },

  // B2F
  {
    x: 7791,
    y: 1817,
    type: ItemType.Hidden,
  },
  {
    x: 8239,
    y: 1639,
    type: ItemType.Hidden,
  },
  {
    x: 7662,
    y: 1684,
    type: ItemType.TM,
  },

  // B3F
  {
    x: 9020,
    y: 1651,
    type: ItemType.Normal,
  },
  {
    x: 8748,
    y: 1512,
    type: ItemType.TM,
  },
  {
    x: 8445,
    y: 1756,
    type: ItemType.Normal,
  },
  {
    x: 8412,
    y: 1756,
    type: ItemType.Normal,
  },
  {
    x: 8668,
    y: 1683,
    type: ItemType.Normal,
  },

  // Whirl Islands

  // Outside
  {
    x: 2292,
    y: 4530,
    type: ItemType.Hidden,
  },
  {
    x: 2694,
    y: 4489,
    type: ItemType.Hidden,
  },
  {
    x: 2791,
    y: 4069,
    type: ItemType.Hidden,
  },
  {
    x: 2758,
    y: 4149,
    type: ItemType.Hidden,
  },
  {
    x: 2158,
    y: 4077,
    type: ItemType.Hidden,
  },

  // Inside
  // 1F
  {
    x: 2648,
    y: 4854,
    type: ItemType.Normal,
  },
  {
    x: 2045,
    y: 5730,
    type: ItemType.Normal,
  },
  {
    x: 2883,
    y: 5596,
    type: ItemType.Hidden,
  },

  // B1F
  {
    x: 1863,
    y: 5392,
    type: ItemType.Normal,
  },
  {
    x: 2007,
    y: 5070,
    type: ItemType.Hidden,
  },
  {
    x: 1974,
    y: 5281,
    type: ItemType.Normal,
  },
  {
    x: 2215,
    y: 5121,
    type: ItemType.Normal,
  },
  {
    x: 2631,
    y: 5044,
    type: ItemType.Hidden,
  },
  {
    x: 2230,
    y: 5552,
    type: ItemType.Normal,
  },
  {
    x: 2564,
    y: 5499,
    type: ItemType.Hidden,
  },
  {
    x: 2678,
    y: 5419,
    type: ItemType.Normal,
  },

  // B2F
  {
    x: 2958,
    y: 5111,
    type: ItemType.Normal,
  },
  {
    x: 3021,
    y: 5049,
    type: ItemType.Normal,
  },

  // Radio Tower
  // Inside
  {
    x: 4516,
    y: 2872,
    type: ItemType.Normal,
  },

  // Basement
  // Exterior
  {
    x: 3675,
    y: 3603,
    type: ItemType.Normal,
  },
  {
    x: 3578,
    y: 3739,
    type: ItemType.Normal,
  },

  // Interior
  {
    x: 4138,
    y: 3597,
    type: ItemType.Normal,
  },
  {
    x: 4234,
    y: 3645,
    type: ItemType.Hidden,
  },
  {
    x: 4490,
    y: 3792,
    type: ItemType.Normal,
  },
  {
    x: 4474,
    y: 3668,
    type: ItemType.Hidden,
  },
  {
    x: 4379,
    y: 3692,
    type: ItemType.TM,
  },

  // Bell Tower
  {
    x: 4079,
    y: 1775,
    type: ItemType.Normal,
  },
  {
    x: 4232,
    y: 1565,
    type: ItemType.Normal,
  },
  {
    x: 4707,
    y: 1689,
    type: ItemType.Normal,
  },
  {
    x: 4755,
    y: 1763,
    type: ItemType.Normal,
  },
  {
    x: 4451,
    y: 1726,
    type: ItemType.Normal,
  },
  {
    x: 3457,
    y: 1348,
    type: ItemType.Normal,
  },
  {
    x: 3618,
    y: 1364,
    type: ItemType.Hidden,
  },
  {
    x: 3807,
    y: 1309,
    type: ItemType.Normal,
  },
  {
    x: 3695,
    y: 1198,
    type: ItemType.Normal,
  },
  {
    x: 4659,
    y: 1394,
    type: ItemType.Normal,
  },
  {
    x: 4627,
    y: 1271,
    type: ItemType.Normal,
  },
  {
    x: 4346,
    y: 1199,
    type: ItemType.Normal,
  },
  {
    x: 3837,
    y: 824,
    type: ItemType.Normal,
  },
  {
    x: 4696,
    y: 1173,
    type: ItemType.Hidden,
  },
  {
    x: 4451,
    y: 1173,
    type: ItemType.Normal,
  },

  // Rt 44
  {
    x: 7933,
    y: 2063,
    type: ItemType.Normal,
  },
  {
    x: 8331,
    y: 2014,
    type: ItemType.Normal,
  },
  {
    x: 8711,
    y: 1987,
    type: ItemType.Hidden,
  },
  {
    x: 8616,
    y: 1880,
    type: ItemType.Normal,
  },

  // Ice Path
  {
    x: 8555,
    y: 913,
    type: ItemType.Hidden,
  },
  {
    x: 9051,
    y: 746,
    type: ItemType.Hidden,
  },
  {
    x: 8324,
    y: 482,
    type: ItemType.Normal,
  },
  {
    x: 8660,
    y: 653,
    type: ItemType.Hidden,
  },
  {
    x: 8485,
    y: 520,
    type: ItemType.Normal,
  },
  {
    x: 9458,
    y: 1396,
    type: ItemType.Normal,
  },
  {
    x: 9157,
    y: 630,
    type: ItemType.TM,
  },
  {
    x: 9474,
    y: 1188,
    type: ItemType.Normal,
  },
  {
    x: 9505,
    y: 1171,
    type: ItemType.Hidden,
  },
  {
    x: 9131,
    y: 871,
    type: ItemType.Normal,
  },
  {
    x: 9131,
    y: 1126,
    type: ItemType.Normal,
  },

  // Dark Cave

  // Blackthorn Side
  {
    x: 8842,
    y: 2509,
    type: ItemType.Hidden,
  },
  {
    x: 8747,
    y: 2854,
    type: ItemType.Normal,
  },
  {
    x: 8300,
    y: 2926,
    type: ItemType.TM,
  },
  {
    x: 8220,
    y: 2960,
    type: ItemType.Hidden,
  },
  {
    x: 8299,
    y: 2410,
    type: ItemType.Hidden,
  },

  // Violet City Side
  {
    x: 8267,
    y: 3256,
    type: ItemType.Hidden,
  },
  {
    x: 8235,
    y: 3284,
    type: ItemType.Normal,
  },
  {
    x: 8347,
    y: 3432,
    type: ItemType.Normal,
  },
  {
    x: 8891,
    y: 3308,
    type: ItemType.Normal,
  },
  {
    x: 9016,
    y: 3440,
    type: ItemType.Hidden,
  },
  {
    x: 8972,
    y: 3674,
    type: ItemType.Normal,
  },
  {
    x: 8811,
    y: 3783,
    type: ItemType.Normal,
  },

  // Rt 45
  {
    x: 9164,
    y: 2652,
    type: ItemType.Normal,
  },
  {
    x: 9292,
    y: 3198,
    type: ItemType.Normal,
  },
  {
    x: 9198,
    y: 3355,
    type: ItemType.Normal,
  },
  {
    x: 9165,
    y: 3604,
    type: ItemType.Normal,
  },
  {
    x: 9227,
    y: 3454,
    type: ItemType.Hidden,
  },
  {
    x: 9437,
    y: 2855,
    type: ItemType.Normal,
  },

  // Rt 46
  {
    x: 8620,
    y: 4151,
    type: ItemType.Normal,
  },
  {
    x: 9082,
    y: 4061,
    type: ItemType.Hidden,
  },

  // Dragon's Den
  {
    x: 10455,
    y: 926,
    type: ItemType.Normal,
  },
  {
    x: 10584,
    y: 1137,
    type: ItemType.Normal,
  },
  {
    x: 9896,
    y: 1146,
    type: ItemType.Normal,
  },
  {
    x: 10007,
    y: 865,
    type: ItemType.Hidden,
  },
  {
    x: 9911,
    y: 1001,
    type: ItemType.Hidden,
  },
  {
    x: 10297,
    y: 1333,
    type: ItemType.Hidden,
  },

  // Mt. Mortar

  // Entrance
  {
    x: 6795,
    y: 1526,
    type: ItemType.Normal,
  },
  {
    x: 6266,
    y: 1339,
    type: ItemType.Normal,
  },
  {
    x: 6154,
    y: 1723,
    type: ItemType.Hidden,
  },

  // Basement
  {
    x: 5327,
    y: 877,
    type: ItemType.Normal,
  },
  {
    x: 5231,
    y: 652,
    type: ItemType.Normal,
  },
  {
    x: 5135,
    y: 579,
    type: ItemType.Normal,
  },
  {
    x: 4768,
    y: 998,
    type: ItemType.Hidden,
  },
  {
    x: 4672,
    y: 814,
    type: ItemType.Normal,
  },
  {
    x: 5072,
    y: 912,
    type: ItemType.Normal,
  },
  {
    x: 5024,
    y: 240,
    type: ItemType.Hidden,
  },

  // Upper Cave
  {
    x: 5094,
    y: 1673,
    type: ItemType.Normal,
  },
  {
    x: 5718,
    y: 1452,
    type: ItemType.Normal,
  },
  {
    x: 5668,
    y: 1586,
    type: ItemType.Hidden,
  },
  {
    x: 5846,
    y: 1351,
    type: ItemType.Hidden,
  },
  {
    x: 5542,
    y: 1466,
    type: ItemType.Hidden,
  },
  {
    x: 5462,
    y: 1405,
    type: ItemType.TM,
  },
  {
    x: 5717,
    y: 1171,
    type: ItemType.Normal,
  },
  {
    x: 5429,
    y: 1159,
    type: ItemType.Normal,
  },
  {
    x: 5253,
    y: 1292,
    type: ItemType.Normal,
  },
  {
    x: 5255,
    y: 1219,
    type: ItemType.Hidden,
  },

  // Lower Cave
  {
    x: 5913,
    y: 229,
    type: ItemType.Hidden,
  },
  {
    x: 5690,
    y: 229,
    type: ItemType.Normal,
  },
  {
    x: 5594,
    y: 426,
    type: ItemType.Normal,
  },
  {
    x: 6042,
    y: 355,
    type: ItemType.Normal,
  },
  {
    x: 6297,
    y: 339,
    type: ItemType.Normal,
  },
  {
    x: 6297,
    y: 681,
    type: ItemType.Normal,
  },
  {
    x: 6088,
    y: 862,
    type: ItemType.Hidden,
  },
  {
    x: 6041,
    y: 555,
    type: ItemType.Normal,
  },
  {
    x: 5817,
    y: 644,
    type: ItemType.Normal,
  },

  // Rt 27
  {
    x: 11369,
    y: 4938,
    type: ItemType.Normal,
  },
  {
    x: 10682,
    y: 4513,
    type: ItemType.Normal,
  },
  {
    x: 12329,
    y: 4757,
    type: ItemType.Normal,
  },
  {
    x: 12574,
    y: 4748,
    type: ItemType.Hidden,
  },
  {
    x: 11529,
    y: 4937,
    type: ItemType.TM,
  },
  {
    x: 13089,
    y: 4952,
    type: ItemType.Hidden,
  },
  {
    x: 12957,
    y: 4798,
    type: ItemType.Hidden,
  },

  // Rt 26
  {
    x: 13634,
    y: 3452,
    type: ItemType.Hidden,
  },
  {
    x: 13427,
    y: 3389,
    type: ItemType.Normal,
  },

  // Victory Road
  {
    x: 12999,
    y: 4353,
    type: ItemType.Normal,
  },
  {
    x: 12743,
    y: 4261,
    type: ItemType.Hidden,
  },
  {
    x: 12886,
    y: 4264,
    type: ItemType.Normal,
  },
  {
    x: 12616,
    y: 4263,
    type: ItemType.Hidden,
  },
  {
    x: 12871,
    y: 4034,
    type: ItemType.Normal,
  },
  {
    x: 12379,
    y: 3547,
    type: ItemType.Hidden,
  },
  {
    x: 13105,
    y: 3193,
    type: ItemType.Hidden,
  },
  {
    x: 13050,
    y: 3734,
    type: ItemType.Hidden,
  },
  {
    x: 12843,
    y: 3511,
    type: ItemType.Normal,
  },
  {
    x: 12896,
    y: 2923,
    type: ItemType.Normal,
  },
  {
    x: 12586,
    y: 3673,
    type: ItemType.Hidden,
  },
  {
    x: 12634,
    y: 3649,
    type: ItemType.Normal,
  },
  {
    x: 12560,
    y: 2884,
    type: ItemType.Normal,
  },
  {
    x: 12348,
    y: 3523,
    type: ItemType.TM,
  },
  {
    x: 12689,
    y: 3146,
    type: ItemType.TM,
  },
  {
    x: 13394,
    y: 2799,
    type: ItemType.Hidden,
  },
  {
    x: 12849,
    y: 2910,
    type: ItemType.Hidden,
  },

  // Frontier Access
  {
    x: 2539,
    y: 3160,
    type: ItemType.Hidden,
  },
];
